













































































import {
  computed,
  defineNuxtComponent,
  PropType,
  ref,
  vue3Model
} from '~/utils/nuxt3-migration'
import ClassifiedQuickSearchCategoryListMobile from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchCategoryListMobile.vue'
import { CategoryId } from '~/models/category/types'
import QuickSearchCategoryMenu from '~/components/car/classifieds/quick-search/QuickSearchCategoryMenu.vue'
import { MobileMenuItem } from '~/models/header/mobile-menu'
import { useI18n } from '~/compositions/i18n'
import { ciCars } from '~/icons/source/thin/cars'
import { ciMotorbikes } from '~/icons/source/thin/motorbikes'
import { ciTrucks } from '~/icons/source/thin/trucks'
import { ciCaravans } from '~/icons/source/thin/caravans'
import { useRouter } from '@nuxtjs/composition-api'
import { ciChevronLeft } from '~/icons/source/regular/chevron-left'

export default defineNuxtComponent({
  components: {
    QuickSearchCategoryMenu,
    ClassifiedQuickSearchCategoryListMobile
  },
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    selectedSearchbarCategory: {
      type: Number as PropType<CategoryId>,
      required: true
    }
  },
  setup(props, { emit }) {
    const visible = computed({
      get() {
        return props.modelValue
      },
      set(newValue: number) {
        emit('update:modelValue', newValue)
      }
    })

    const { t } = useI18n()
    const router = useRouter()

    const menusContainerRef = ref(null)
    const selectedMenus = ref([])
    const submenusTitles = ref([])
    const scrollOffset = ref(0)
    const transitioning = ref(false)
    const overflowClass = ref('tw-overflow-y-auto tw-overflow-x-hidden')

    function initiateTransition() {
      transitioning.value = true
      overflowClass.value = 'tw-overflow-visible'
      setTimeout(onTransitionEnd, 150)
    }

    function menuClicked(event: Event, title: string, reset: boolean = false) {
      if (reset) {
        selectedMenus.value = event.target.value ? [event.target.value] : []
        submenusTitles.value = title ? [title] : []
      } else {
        selectedMenus.value.push(event.target.value)
        submenusTitles.value.push(title)
      }

      if (selectedMenus.value.length) {
        if (menusContainerRef.value?.scrollTop) {
          scrollOffset.value = menusContainerRef.value?.scrollTop
        }
        initiateTransition()
      }
    }

    function onTransitionEnd() {
      if (!selectedMenus.value.length) {
        scrollOffset.value = 0
      }
      overflowClass.value = selectedMenus.value.length
        ? 'tw-overflow-visible'
        : 'tw-overflow-y-auto tw-overflow-x-hidden'

      transitioning.value = false
    }

    const topMenu = computed<MobileMenuItem[]>(() => {
      return [
        {
          key: 'top-cars',
          title: t('cars'),
          icon: ciCars,
          link: router.resolve({
            name: '__classifieds_quick_search',
            params: { root: 'vehicles', category: 'cars' }
          }).href,
          useNuxtLink: true
        },
        {
          key: 'top-bikes',
          title: t('bikes::vehicles'),
          icon: ciMotorbikes,
          link: router.resolve({
            name: '__classifieds_quick_search',
            params: { root: 'vehicles', category: 'bikes' }
          }).href,
          useNuxtLink: true
        },
        {
          key: 'top-commercials',
          title: t('commercials::vehicles'),
          icon: ciTrucks,
          link: router.resolve({
            name: '__classifieds_quick_search',
            params: { root: 'vehicles', category: 'commercials' }
          }).href,
          useNuxtLink: true
        },
        {
          key: 'top-motorhomes',
          title: t('campers::vehicles'),
          icon: ciCaravans,
          link: router.resolve({
            name: '__classifieds_quick_search',
            params: { root: 'vehicles', category: 'campers' }
          }).href,
          useNuxtLink: true
        }
      ]
    })

    function navBackClicked() {
      if (selectedMenus.value.length === 0) {
        return
      }
      selectedMenus.value = selectedMenus.value.slice(0, -1)
      submenusTitles.value = submenusTitles.value.slice(0, -1)

      initiateTransition()
    }

    function navigateFunction(e: Event, link: string) {
      if (e) {
        e.preventDefault()
      }
      router.push({ path: link }).catch(_e => {})
      emit('hide')
    }
    const headerText = computed(() => {
      if (submenusTitles.value.length) {
        return submenusTitles.value[submenusTitles.value.length - 1]
      }
      return t('search')
    })

    return {
      visible,
      selectedMenus,
      submenusTitles,
      menuClicked,
      menusContainerRef,
      transitioning,
      scrollOffset,
      overflowClass,
      navigateFunction,
      onTransitionEnd,
      ciChevronLeft,
      topMenu,
      headerText,
      navBackClicked
    }
  }
})
